<template>
  <div id="divider" class="divider push-v--md--x-large">
    <section class="divider--wrapper">
      <section class="container">
        <!-- <div class="row"> -->
        <h1 class="divider--title">{{ title }}</h1>
        <!-- </div> -->
      </section>
    </section>
  </div>
</template>
<script>
export default {
  setup() {

  },
  props: {
    title: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_destination-divider.scss';
</style>
